import { render, staticRenderFns } from "./SplitOrder.vue?vue&type=template&id=eeb0b774&scoped=true&"
import script from "./SplitOrder.vue?vue&type=script&lang=js&"
export * from "./SplitOrder.vue?vue&type=script&lang=js&"
import style0 from "./SplitOrder.vue?vue&type=style&index=0&id=eeb0b774&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eeb0b774",
  null
  
)

export default component.exports